import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const assetDefinition = api(async function asset(id) {
    if (!id) return null
    return query(
        gql`
            query GetAsset($id: String!) {
                asset(id: $id) {
                    id
                    picture
                    tag
                    description
                    system
                    modified
                    model
                    name
                    type
                    manufacturer
                    location
                    floor
                    facility
                    space
                    category
                    assetRegister
                    annualServiceDate
                    assetCriticality
                    carbon
                    code
                    condition
                    energyEfficiency
                    serialNumber
                    warrantyExpiry
                    sfg20Code
                    installationDate
                    expectedLifespan
                    barcode
                }
            }
        `,
        {
            id,
        },
        {
            returns: "asset",
            transform: (i) => ({
                ...i,
                picture: i.picture ? { documents: i.picture.map((o, i) => ({ href: o, id: i })) } : undefined,
            }),
        }
    )
})
